var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 132,
    viewBox: "0 0 182 132",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1167_14844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.9 8.36014C75.9359 -10.2173 22.0062 21.7213 9.52363 48.0657C-20.4501 111.325 31.9301 140.519 54.973 129.841C64.5927 125.382 72.4504 117.77 80.0447 110.363C91.4476 99.3367 106.556 92.9825 122.398 92.5497C134.6 92.2688 146.743 95.5485 158.909 94.5854C171.076 93.6224 181.823 76.8139 181.493 64.5929C180.99 45.9397 169.117 28.2806 120.9 8.36014Z",
    fill: "#F2F3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.861 6.70251H30.1395C26.1032 6.70251 22.8311 9.9803 22.8311 14.0237V109.977C22.8311 114.02 26.1032 117.298 30.1395 117.298H151.861C155.897 117.298 159.169 114.02 159.169 109.977V14.0237C159.169 9.9803 155.897 6.70251 151.861 6.70251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.861 117.528H30.1397C28.1413 117.526 26.2253 116.73 24.8122 115.314C23.3991 113.898 22.6043 111.979 22.6021 109.977V14.0238C22.6043 12.0218 23.3991 10.1025 24.8122 8.68695C26.2253 7.27135 28.1413 6.47506 30.1397 6.47278H151.861C153.86 6.47506 155.776 7.27135 157.189 8.68695C158.602 10.1025 159.397 12.0218 159.399 14.0238V109.977C159.397 111.979 158.602 113.898 157.189 115.314C155.776 116.73 153.86 117.526 151.861 117.528ZM30.1397 6.93221C28.2629 6.93437 26.4635 7.68221 25.1364 9.01167C23.8093 10.3411 23.0628 12.1436 23.0607 14.0238V109.977C23.0628 111.857 23.8093 113.66 25.1364 114.989C26.4635 116.319 28.2629 117.067 30.1397 117.069H151.861C153.738 117.067 155.538 116.319 156.865 114.989C158.192 113.66 158.938 111.857 158.94 109.977V14.0238C158.938 12.1436 158.192 10.3411 156.865 9.01167C155.538 7.68221 153.738 6.93437 151.861 6.93221H30.1397Z",
    fill: "#292A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.17 14.0243V27.907H22.832V14.0243C22.8318 13.0626 23.0207 12.1104 23.3879 11.2219C23.7551 10.3334 24.2935 9.5261 24.9722 8.84609C25.651 8.16608 26.4569 7.62669 27.3438 7.25875C28.2307 6.8908 29.1813 6.7015 30.1413 6.70166H151.862C153.8 6.70199 155.659 7.47364 157.03 8.84689C158.4 10.2201 159.17 12.0825 159.17 14.0243Z",
    fill: "#049A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.416 28.1536H22.5859V14.0243C22.5878 12.0176 23.3844 10.0936 24.8008 8.67449C26.2173 7.25543 28.1378 6.45723 30.1411 6.45508H151.862C153.865 6.45756 155.785 7.25589 157.201 8.67491C158.618 10.0939 159.414 12.0178 159.416 14.0243V28.1536ZM23.0788 27.6604H158.924V14.0243C158.922 12.1486 158.177 10.3501 156.853 9.0236C155.529 7.69706 153.734 6.95072 151.862 6.9483H30.1411C28.2684 6.95039 26.473 7.6966 25.1489 9.02318C23.8248 10.3498 23.0801 12.1484 23.0783 14.0243L23.0788 27.6604Z",
    fill: "#049A77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1212 37.7305H29.4932V57.0561H49.1212V37.7305Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1212 62.4301H29.4932V81.7557H49.1212V62.4301Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1212 87.1299H29.4932V106.456H49.1212V87.1299Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9664 37.7305H55.3384V57.0561H74.9664V37.7305Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9664 62.4301H55.3384V81.7557H74.9664V62.4301Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.551 37.7305H80.9229V57.0561H100.551V37.7305Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.551 62.4301H80.9229V81.7557H100.551V62.4301Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86 37.7305H107.231V57.0561H126.86V37.7305Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86 62.4301H107.231V81.7557H126.86V62.4301Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9664 87.1299H55.3384V106.456H74.9664V87.1299Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.551 87.1299H80.9229V106.456H100.551V87.1299Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.507 37.7305H132.879V57.0561H152.507V37.7305Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.507 62.4301H132.879V81.7557H152.507V62.4301Z",
    fill: "#D7D7D7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1167_14844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 132,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatus);
export default __webpack_public_path__ + "static/media/emptyStatus.8ff36cf377da04667ee19f138cc1d64e.svg";
export { ForwardRef as ReactComponent };